export var classListSupport = 'classList' in document.createElement('_');


// WEBPACK FOOTER //
// ./~/tiny-slider/src/helpers/classListSupport.js